enum TYPE_DRAG_DROP {
  column = 'column',
  card = 'card',
}

export {
  TYPE_DRAG_DROP,
};
